<template>
	<IconBase icon-name="guides">
		<path d="M5,4 19,20" class="grayStroke" opacity="0.5" />
		<circle r="3" cy="14" cx="14" class="whiteFill blueStroke" />
	</IconBase>
</template>

<script>
import IconBase from './IconBase';
export default {
	components: {
		IconBase
	}
};
</script>
